// extracted by mini-css-extract-plugin
export default {"container":"BHr2wB7xkbcvEstStOFQ","nickname":"ymgOldENTS4RSjQCOG3s","oneLineNickname":"t86smHBuNDn_I7RqDeHZ","position":"G1vn0fpPowwCwt59bJXw","rank":"nX5qxU2o9gOT7dwkkuCA"};